import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "product-card" }
const _hoisted_2 = { class: "flex justify-content-center mb-3" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "no-wrap app-label-small font-bold text-default-gray mt-2 col-6 ml-2" }
const _hoisted_5 = { class: "flex mt-4 justify-content-between flex-wrap ml-3 mr-3 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-column\"><span class=\"flex app-label-small text-gray-l1 font-bold\"> Statut </span><span class=\"flex app-label-small text-gray-l1 font-bold mt-4\"> Marque </span><span class=\"flex app-label-small text-gray-l1 font-bold mt-4\"> Installé le </span><span class=\"flex app-label-small text-gray-l1 font-bold mt-4\"> Fonction </span></div>", 1)
const _hoisted_7 = { class: "flex flex-column align-items-end" }
const _hoisted_8 = { class: "flex app-label-small text-default-gray font-bold mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-small text-default-gray font-bold mt-4" }, " 10/06/2022 ", -1)
const _hoisted_10 = { class: "col-2 flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex mt-4 ml-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "line-section-gray",
    style: {"border":"1px solid #eaeef0"}
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "flex app-label-small text-gray-l1 font-bold" }, " Ouvrir fiche ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.object.imgURL,
        alt: _ctx.object.name,
        style: {"height":"206px","width":"202px"},
        class: "mt-1"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.object.name), 1),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", {
          class: _normalizeClass(["state-tag app-label-micro font-bold text-white", _ctx.object?.state == 'REACHABLE' ? 'bg-green' : 'bg-red'])
        }, _toDisplayString(_ctx.stateName(_ctx.object?.state)), 3),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.object?.brand), 1),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.object?.factors, (factor) => {
            return (_openBlock(), _createElementBlock("div", { key: factor }, [
              _createElementVNode("i", {
                class: _normalizeClass('ci-data-' + factor)
              }, null, 2)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_11,
    _hoisted_12
  ]))
}